import { Heading, Link, Section } from 'components'
import { graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

const PostSingle = ({ data }) => {
  const post = data.wpPost
  const featuredImage = getImage(data.wpPost?.featuredImage?.node?.localFile)

  return (
    <Section>
      <div className="mx-auto max-w-3xl post-single">
        <Heading level="1">{post.title}</Heading>

        <div className="text-gray-400 text-sm my-8">
          Last updated on {post.date} by{' '}
          <Link to={post.author.node.uri}>{post.author.node.name}</Link> in{' '}
          <span className="uppercase">
            {post.categories.nodes.map((category, index) => {
              const categoryNumber = post.categories.nodes.length - 1

              return (
                <Link to={category.uri}>
                  {index === categoryNumber
                    ? category.name
                    : `${category.name}, `}
                </Link>
              )
            })}
          </span>
        </div>

        {featuredImage && <GatsbyImage image={featuredImage}></GatsbyImage>}

        <div dangerouslySetInnerHTML={{ __html: post.content }} />
      </div>
    </Section>
  )
}

export const query = graphql`
  query GET_POST($id: String!) {
    wpPost(id: { eq: $id }) {
      id
      slug
      title
      date(formatString: "MMMM DD, YYYY")
      content
      author {
        node {
          id
          name
          uri
        }
      }
      categories {
        nodes {
          id
          name
          uri
        }
      }
      featuredImage {
        node {
          mediaItemUrl
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(width: 1600)
            }
          }
        }
      }
      categories {
        nodes {
          id
          name
        }
      }
    }
  }
`
export default PostSingle
